<script setup lang="ts">
import Modal from '~/components/modals/Modal.vue';
import { money } from '~/helpers/product/productHelper';
import { MODAL_MULTIPLE_PAYMENT } from '~/store/modalStore';

const props = defineProps<{
  isModalVisible: boolean
  closeModal: () => void
}>()

const {
  isModalVisible,
  closeModal,
} = toRefs(props)

const config = useRuntimeConfig();

const klarnaMin = ref(parseInt(config.public.klarnaMin as string));
const klarnaMax = ref(parseInt(config.public.klarnaMax as string));
const paypalMin = ref(parseInt(config.public.paypalMin as string));
const paypalMax = ref(parseInt(config.public.paypalMax as string));
</script>

<template>
  <Modal
      :id="MODAL_MULTIPLE_PAYMENT"
      classes="modal__inner--medium"
      :is-visible="isModalVisible"
      :title="$t('www.popup_payments.title')"
      @close="closeModal">
    <div>
      <div class="weight--interbold mb-1 c-blue-light size--body">
        {{ $t('www.popup_payments.subtitle_1') }}
      </div>
      <ul class="mb-2 size--headline popup-payments__list-style">
        <li>
          {{ $t('www.popup_payments.list_1.first') }}
        </li>
        <li>
          {{ $t('www.popup_payments.list_1.second') }}
        </li>
        <li>
          {{ $t('www.popup_payments.list_1.third') }}
        </li>
      </ul>

      <div class="weight--interbold mb-1 c-blue-light size--body">
        {{ $t('www.popup_payments.subtitle_2') }}
      </div>
      <div class="size--headline">
        {{ $t('www.popup_payments.list_2.text') }}
      </div>
      <ol class="size--headline popup-payments__list-style">
        <li>
          {{ $t('www.popup_payments.list_2.first') }}
        </li>
        <li>
          {{ $t('www.popup_payments.list_2.second') }}
        </li>
        <li>
          {{ $t('www.popup_payments.list_2.third') }}
        </li>
        <li>
          {{ $t('www.popup_payments.list_2.fourth') }}
        </li>
      </ol>

      <div class="df jcc mt-1 mb-1 popup-payments__list-app">
        <div class="df fdc aic mr-2 popup-payments__app">
          <svg class="cicon cicon--unset ml-h mr-h" style="width: 100px;height: 90px;"><use xlink:href="#klarna-v2"/></svg>
          <span class="weight--intersbold size--body c-navy-std">{{ $t('www.popup_payments.limit') }}</span>
          <span>{{ $t('www.popup_payments.klarna_limit', {
                  'klarna3xMin': money(klarnaMin),
                  'klarna3xMax': money(klarnaMax),
                }) }}
          </span>
        </div>
        <div class="popup-payments__vertical-line"/>
        <div class="df fdc aic ml-2 popup-payments__app">
          <svg class="cicon cicon--unset ml-h mr-h" style="width: 100px;height: 90px;"><use xlink:href="#paypal-v2"/></svg>
          <span class="weight--intersbold size--body c-navy-std">{{ $t('www.popup_payments.limit') }}</span>
          <span>{{ $t('www.popup_payments.paypal_limit', {
                  'paypal4xMin': money(paypalMin),
                  'paypal4xMax': money(paypalMax),
                }) }}
          </span>
        </div>
      </div>
    </div>
  </Modal>
</template>
